export const GET_GRADES = "GET_GRADES";
export const GET_GRADE_BY_ID = "GET_GRADE_BY_ID";
export const UPDATE_GRADE = "UPDATE_GRADE";
export const DELETE_GRADE = "DELETE_GRADE";
export const CREATE_GRADE = "CREATE_GRADE";
export const GET_PROGRAMS_BY_GRADE = "GET_PROGRAMS_BY_GRADE";
